import { FilterBuilder } from '@/components/filters/FilterBuilder'
import { FilterState, FilterableField } from '@/components/filters/types'
import AudiencePreview from './AudiencePreview'

interface AudienceSectionProps {
  audienceType: 'dynamic' | 'fixed'
  onAudienceTypeChange: (value: 'dynamic' | 'fixed') => void
  audienceRules: FilterState
  onAudienceRulesChange: (state: FilterState) => void
  filterableFields: FilterableField[]
}

export default function AudienceSection({
  audienceType,
  onAudienceTypeChange,
  audienceRules,
  onAudienceRulesChange,
  filterableFields,
}: AudienceSectionProps) {
  return (
    <div className="p-6 space-y-4 border-t border-gray-200">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Tipo de Público
        </label>
        <div className="flex gap-4">
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="audience_type"
              value="dynamic"
              checked={audienceType === 'dynamic'}
              onChange={() => onAudienceTypeChange('dynamic')}
              className="text-blue-600 focus:ring-blue-500"
            />
            <div>
              <span className="text-sm font-medium text-gray-700">Dinâmico</span>
              <p className="text-xs text-gray-500">
                Enviar para usuários que correspondem agora e no futuro
              </p>
            </div>
          </label>
          <label className="flex items-center gap-2">
            <input
              type="radio"
              name="audience_type"
              value="fixed"
              checked={audienceType === 'fixed'}
              onChange={() => onAudienceTypeChange('fixed')}
              className="text-blue-600 focus:ring-blue-500"
            />
            <div>
              <span className="text-sm font-medium text-gray-700">Fixo</span>
              <p className="text-xs text-gray-500">
                Enviar apenas para usuários que correspondem agora (expira em 30 dias)
              </p>
            </div>
          </label>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Regras de Público
        </label>
        <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
          <FilterBuilder
            fields={filterableFields}
            value={audienceRules}
            onChange={onAudienceRulesChange}
          />
          {audienceRules.filters.length === 0 && (
            <p className="text-sm text-gray-500 mt-2">
              Nenhum filtro adicionado. A mensagem será enviada para todos os usuários.
            </p>
          )}
          <AudiencePreview audienceRules={audienceRules} />
        </div>
      </div>
    </div>
  )
}
